<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap class="mt-4" justify-space-around>
      <v-flex xs12>
        <h1>
          {{ $t('agreementManage') }}
        </h1>
      </v-flex>
      <v-flex xs12>
        <v-flex xs12>
          <v-card>
            <div style="padding: 20px">
              <v-card-title>
                <h2>Centraliza toda tu operación logística desde un solo lugar</h2>
              </v-card-title>

              <v-card-text class="grey--text">
                <h3 class="mb-4">
                  Usa tus convenios con las paqueterías sobre nuestra tecnología.
                </h3>
                <p>
                  <font-awesome-icon size="1x" :color="tickColor" icon="check"></font-awesome-icon>
                  Controla todas tus cuentas con las paqueterías en un mismo sitio.
                </p>
                <p>
                  <font-awesome-icon size="1x" :color="tickColor" icon="check"></font-awesome-icon>
                  Detecta cargos por reexpedición y futuros cobros por sobrepeso.
                </p>
                <p>
                  <font-awesome-icon size="1x" :color="tickColor" icon="check"></font-awesome-icon>
                  Gestiona permisos y roles sobre tu operación logística.
                </p>
                <p>
                  <font-awesome-icon size="1x" :color="tickColor" icon="check"></font-awesome-icon>
                  Un Asesor se pondrá en contacto.
                </p>
              </v-card-text>

              <v-btn color="primary" @click="goTo('agreementCarriers')">Conectar convenio</v-btn>
              <v-btn color="info" medium outline @click="goTo('clientCarriers')" :disabled="false" :loading="false">
                {{ $t('attrs.my_carriers') }}
              </v-btn>
            </div>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Setting from '@/client/setting'

export default {
  name: '',

  props: {},

  data () {
    return {
      tickColor: process.env.VUE_APP_COLOR
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
  },

  watch: {
  },

  async mounted () {
    // await this.$auth.getCurrentUser()

    //dynamic solution - setting value check in route .js file
    var ownAgreements = await Setting.byKey('user_own_agreements') || {}
    if (ownAgreements && ownAgreements.value == '0') this.goTo('dashboard')
  }
}
</script>
